/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["#processing-overlay[_ngcontent-%COMP%]{position:absolute;width:100%;height:100%;background:rgba(255,255,255,.7);text-align:center;z-index:999;margin-top:-1px;margin-left:-1px;padding-top:50px}\n/*# sourceMappingURL=import.component.css.map*/"];
export { styles as styles };
